import Skeleton from "@/common/components/Skeleton";
import React from "react";
import { useEstablishmentMap } from "../../stores/useEstablishmentMap.store";
import { twMerge } from "tailwind-merge";

export const LoadingEstablishmentTooltipProductPrices = ({ cardList }: { cardList?: boolean; }) => {
  const { colorScheme } = useEstablishmentMap();

  return (
    <div className={twMerge('flex-col p-3 rounded-b-md', colorScheme === 'dark' && cardList && 'bg-white-100')}>
      <div className="flex items-end">
        {new Array(3).fill(null).map((_, index) => (
          <React.Fragment key={`loading_price_${index}`}>
            {index > 0 && <div className="bg-gray-500 w-[1px] h-10 mr-2 self-center" />}

            <div className="flex flex-col gap-1 w-1/3">
              <Skeleton width={64} height={16} />

              <Skeleton width={72} />

              <Skeleton width={84} height={12} />
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export const LoadingEstablishmentTooltipDetails = ({ cardList }: { cardList?: boolean; }) => {
  return (
    <div className="w-[336px] flex flex-col">
      <div className="flex flex-col gap-1 p-3 bg-slate-50/10">
        <div className="flex gap-2 items-center">
          <Skeleton circle height={36} />

          <Skeleton width={156} />
        </div>

        <Skeleton width={156} height={16} />
      </div>

      {!cardList && <LoadingEstablishmentTooltipProductPrices />}
    </div>
  );
};
